<template>
    <div class="container feedback template-bg-gray" v-bind:class="{'my-position-relative': isStatus}">
        <md-card class="request-status loop_container bg-transparent update-request-form-common" v-if="isStatus">
            <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
                <div class="card form-wrapper text-center p-20">
                    <h4 class="template-custom-title" v-html="statusMsg"></h4>
                </div>
            </md-card-content>
        </md-card>
        <div class="row" v-if="!isStatus">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec">
                <div class="loop_container bg-transparent update-request-form-common">
                    <div class="card form-wrapper" v-bind:class="{'thankupageplr88': success}">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <img :src="logoURL" class="top-logo custom-logo" :alt="community.content && community.content.parameter2 ? community.content.parameter2 : 'Community Logo'">
                            </div>
                        </div>
                        <div class='request-respnose-class my-text-center common-space-from-logo'
                            v-bind:class="{'email-actionpage-tmsg plr10': !success}">
                            <h1 class="template-title" v-if="!success">Say thanks or keep chatting</h1>
                                <h1 class="template-title" aria-live="polite" v-if="success">Thank you!</h1>
                            <p class="custom-content my-text-center" v-if="!success">
                                Showing your appreciation for a response is critical to building your network.
                            </p>
                        </div>
                        <form @submit.prevent="submitResponse()" v-show="!success" class="template-form">
                            <div class="row">
                                <div class="col-md-12">
                                    <div :class="[{ 'b-error': errors.has('comment') }, 'form-group', 'pd-remove', 'unsubscribe-height']"
                                        class="template-input-text-area" style="position: relative;">
                                        <textarea @blur="handleBlur" @focus="handleFocus" class="form-control placeholder-bold" name="comment" id="textarea" rows="10" aria-label="Say thank you"
                                            v-model="comment" :placeholder="commentPlaceholder"
                                            v-validate.continues="'required|max:500'" :maxlength="max" required aria-required="true"
                                            @input="sanitizeComment"
                                            v-bind:class="{ 'request-form-error-border': errors.has('comment') }"></textarea>
                                        <button type="button" @click="getThankYou(giveText)"
                                            style="position: absolute; bottom: 10px; right: 10px; border: none; background: none; cursor: pointer;" class="hover-shadow" :disabled="loading" aria-label="Our magic wand offers ways to thank your advisor." :aria-busy="loading">
                                            <template v-if="loading">
                                                <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                                            </template>
                                            <template v-else>
                                                <div style="display: flex; align-items: center; gap: 4px;">
                                                    <p class="magic-wand-ty" style="margin: 0;">View Examples</p>
                                                    <img :src="this.magicWandIcon" class="magic-wand-img" alt="" width="20" height="20">
                                                </div>
                                            </template>
                                        </button>
                                        <p class="error" v-if="errors.has('comment')">{{ errors.first('comment') }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="btn-block mlr0">
                                <div class="">
                                    <div class="form-group pd-remove unsubscribe-btn text-center">
                                        <button v-bind:style="reviewBtn" type="submit" name="unsubscribe"
                                            class="btn btn_info template-review-submit template-button template-button-width"
                                            >Submit</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row mlr0">
                                <div class="col-md-12 plr10 text-center">
                                    <a v-if="community.content.responseEngagementTip" target="_blank"
                                        v-bind:href="community.content.responseEngagementTip"
                                        class="view-profile-link">Not sure what to say?</a>
                                </div>
                            </div>
                        </form>
                        <div v-show="!success">
                            <div class="give-section">
                                <div class="row my">
                                    <div class="col-md-12">
                                        <h2 class="email-request-title text-center">Here's how they helped.</h2>
                                    </div>
                                </div>
                                <div class="email-request-review">
                                    <div class="template-request-review">
                                        <h3>{{advisorDetails.first}} {{advisorDetails.last}} <a
                                                class="view-profile-link" target="_blank" v-if="advisorDetails.linkedIn"
                                                v-bind:href="advisorDetails.linkedIn">(View Profile)</a></h3>
                                        <span class="email-custom" v-if="$lodash.has(advisorDetails.emails, 0)">{{advisorDetails.emails[0]}}
                                        </span>
                                        <span class="email-custom" v-if="givesEmail">{{givesEmail}}</span>
                                        <p class="font-color" v-html="giveText"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="request-section">
                                <div class="row my">
                                    <div class="col-md-12">
                                        <h2 class="email-request-title text-center">Here's what you asked</h2>
                                    </div>
                                </div>
                                <div class="email-request-review">
                                    <div class="template-request-review">
                                        <h3>{{createdByMember.first}} {{createdByMember.last}} <a
                                                class="view-profile-link" target="_blank" v-if="advisorDetails.linkedIn"
                                                v-bind:href="advisorDetails.linkedIn">(View Profile)</a></h3>
                                        <span class="email-custom" v-if="$lodash.has(createdByMember.emails, 0)">
                                            {{createdByMember.emails[0]}}
                                        </span>
                                        <h3>{{ask.subject}}</h3>
                                        <p class="font-color">{{ask.text}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer>
                        <ul class="list-inline text-center footer-links">
                            <li>
                                <a :href="community.content.landingPageURL" target="_blank" class="links"
                                    v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length"
                                    tabindex="0">Learn More</a>
                                <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
                            </li>
                            <li>
                                <a :href="community.content.termsConditionsURL" target="_blank" class="links"
                                    v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length"
                                    tabindex="0">Terms Of Use [pdf]</a>
                                <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use [pdf]</a>
                            </li>
                            <li>
                                <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank"
                                    v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt
                                    Out</a>
                                <a href="javascript:void(0)" v-else>Opt Out</a>
                            </li>
                        </ul>
                    </footer>
                    <div class="unsubscribe-community-logo">
                        <a :href="(community.content && community.content.landingPageURL) || 'https://www.protopia.co'" target="_blank"><img :src="footerLogoURL" :alt="'Community Logo of '+ community.content.parameter2"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import API from "../services/API";
    import { sanitizeInput } from '../utils/sanitizer';
    import '@/styles/Spinner.css';
    import '@/styles/RequestResponse.css'
    import { getFooterURL, getLogoURL } from "../helpers/getCustomSettings";
    export default {
      props: ["communityId", "askId", "giveId"],
      data() {
        return {
            api: new API(),
            ask: {},
            community: {},
            createdByMember: {},
            success: false,
            email: '',
            commentPlaceholder: "[Click here to edit]\nWrite a quick 'thank you' \n\nPro tip: Let the individual know if and when you plan on acting on the advice, and that you will follow up when you have done so.\n\n",
            fullPage: true,
            max: 500,
            loading: false,
            adviser: {},
            comment: "",
            phoneNo: '',
            reviewBtn: {
                background: '#9178A0',
                color: '#ffffff'
            },
            magicWandIcon: 'https://storage.googleapis.com/protopia/app/icons/wand.png',
            isStatus: true,
            statusMsg: '',
            logoURL: "",
            footerLogoURL: "",
            giveText: "",
            advisorDetails: {},
            givesEmail: "",
        };
    },
    created() {
        if (!this.askId || !this.giveId) {
        	this.$router.push('/');
        }
        this.loadData();
        const dict = {
    		custom: {
    		    comment: {
    		        required: 'Please enter your response comment'
                }
    		}
    	};
    	this.$validator.localize('en', dict);
    },
    methods: {
        handleBlur() {
            this.commentPlaceholder = "[Click here to edit]\nWrite a quick 'thank you' \n\nPro tip: Let the individual know if and when you plan on acting on the advice, and that you will follow up when you have done so.\n\n";
        },
        handleFocus() {
              this.commentPlaceholder = '';
          },
        getThankYou: async function (advisorResponse) {
            this.loading = true;
            try {
                const response = await this.api.post(`asks/thankyou`, {
                    advisorResponse
                });
                this.comment = response.data.email_message;
            } catch (err) {
                console.log(err);
            } finally {
                this.loading = false;
            }
        },
        sanitizeComment(e) {
            this.comment = sanitizeInput(e.target.value);
        },
        loadData: async function() {
            localStorage.setItem('community_id', this.communityId);
            await this.$nextTick(); // Ensure localStorage is committed before API calls
            await this.api.get(`asks/${this.askId}`).then(async ask => {
                this.ask = ask.data;
                if (this.ask.status === '(8) Rejected' || this.ask.status === '(7) Closed') {
                    // console.log("this.community :", this.ask.community);
                    let closeMessage = this.ask.community.content.closeRequestMessage;
                    this.statusMsg = closeMessage;
                } else {
                    this.isStatus = false;
                }
                if (this.ask) {
                    this.community = this.ask.community;
                    document.title = this.community.name + " | Thank You";
                    const customSettings = this.community.customSettings;
                    this.logoURL = getLogoURL(customSettings);
                    this.footerLogoURL = getFooterURL(customSettings);
                    this.reviewBtn = {
                        background: this.community.customSettings.primaryBtnBgColor,
                        color: this.community.customSettings.primaryTxtColor
                    };
                    this.createdByMember = this.ask.createdByMemberID;
                    if (this.giveId) {
                        this.giveText = this.ask.gives.find(give => give._id === this.giveId).insight;
                        var advisorId = this.ask.gives.find(give => give._id === this.giveId).advisors[0];
                        if (typeof advisorId === 'undefined') {
                            this.givesEmail = this.ask.gives.find(give => give._id === this.giveId).email;
                        }
                        await this.api.get(`members/${advisorId}`).then(member => {
                            this.advisorDetails = member.data;
                            var giveData = this.ask.gives.find(
                                give => give._id === this.giveId
                            );
                            var action = this.ask.gives.find(
                                give => give._id === this.giveId
                            ).action;
                            var insight = this.ask.gives.find(
                                give => give._id === this.giveId
                            ).insight;
                            if (typeof action !== 'undefined' && action.search(/Share Advice/i) !== -1) {
                                this.giveText = `<p>${this.giveText}</p>`;
                            } else if (typeof action !== 'undefined' && action.search(/Call Me/i) !== -1) {
                                var phone = "";
                                phone = this.ask.gives.find(give => give._id === this.giveId).phoneNo;
                                if (phone && typeof phone !== 'undefined' && phone !== '') {
                                    let callMessage = giveData.callMessage ? `${giveData.callMessage}` : ''
                                    this.giveText = `<p>${giveData.callText ? `${callMessage} \n Please call or text me at: ${phone}` : `${callMessage} \n Please call me: ${phone}`}</p>`
                                }
                            } else if (typeof action !== 'undefined' && action.search(/Let's Connect/i) !== -1) {
                                if (typeof insight !== 'undefined' && insight !== '') {
                                    this.giveText = `<p>${insight}</p>`;
                                }
                            }
                        });
                    }
                }
            });
    	},
        submitResponse: async function() {
            this.$validator.validateAll().then(async result => {
                if (result) {
                    document.title = 'Thank You';
                    this.success = true;
                    await this.api.post(`asks/${this.askId}/add-request-response`, { giveId: this.giveId, comment: this.comment ? this.comment : '' }).then(response => {
                        if (response.data.error) {
                            this.$validator.reset();
                            this.comment = '';
                            return this.$toast.error(response.data.error);
                        }
                        // document.title = 'Thank You';
                        // this.success = true;
                    });
                }
            });
        }
    },
};
</script>






// WEBPACK FOOTER //
// src/components/RequestResponse.vue